import { useLayoutEffect } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

/**
 * `BrowserRouter` behält die Scrollposition beim Seitenwechsel bei – eine neue
 * Seite öffnete sonst auf der Höhe der alten. Neue Seiten (Klick, Link)
 * beginnen oben; Zurück/Vor (POP) überlässt die Position dem Browser.
 * Nur der Pfad zählt, damit Filter in der Query nicht nach oben springen.
 */
export function ScrollToTop() {
  const { pathname } = useLocation();
  const type = useNavigationType();
  useLayoutEffect(() => {
    if (type !== 'POP') window.scrollTo(0, 0);
  }, [pathname]); // eslint-disable-line react-hooks/exhaustive-deps
  return null;
}
